<section class="google-workspace-service">
  <div class="box">
    <div class="box-content">
      <h3 class="box-content__title"
        ><span>{{ 'GOOGLE_WORKSPACE.SERVICE.HEADING' | translate }}</span></h3
      >
    </div>
    <div class="box-wrapper">
      <ng-container *ngFor="let item of contentData; let i = index">
        <a [href]="item.link" target="_blank" rel="noopener noreferrer">
          <div class="box-wrapper__element">
            <div class="element-block">
              <div class="element-block__main">
                <div class="element-block__main--img">
                  <img
                    class="img-layout"
                    [src]="item.image"
                    [alt]="'GOOGLE_WORKSPACE.SERVICE.ALT.' + (i + 1) | translate"
                  />
                </div>
                <div class="element-block__main--title">
                  <span>{{ 'GOOGLE_WORKSPACE.SERVICE.ALT.' + (i + 1) | translate }}</span>
                </div>
              </div>
            </div>
          </div>
        </a>
      </ng-container>
    </div>
  </div>
</section>
